var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65003 0.349531L0.860031 3.13953C0.540031 3.44953 0.76003 3.98953 1.21003 3.98953H3.00003V9.99953C3.00003 10.5495 3.45003 10.9995 4.00003 10.9995C4.55003 10.9995 5.00003 10.5495 5.00003 9.99953V3.98953H6.79003C7.24003 3.98953 7.46003 3.44953 7.14003 3.13953L4.35003 0.349531C4.16003 0.159531 3.84003 0.159531 3.65003 0.349531ZM11 14.0095V7.99953C11 7.44953 10.55 6.99953 10 6.99953C9.45003 6.99953 9.00003 7.44953 9.00003 7.99953V14.0095H7.21003C6.76003 14.0095 6.54003 14.5495 6.86003 14.8595L9.65003 17.6395C9.85003 17.8295 10.16 17.8295 10.36 17.6395L13.15 14.8595C13.47 14.5495 13.24 14.0095 12.8 14.0095H11Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/exportIcon.b9f0633b.svg";
export { ForwardRef as ReactComponent };